export const packaging_Details = {
	company_name: '',
	company_address: '',
	pkg_person_contact_name: '',
	email: '',
	vendor_code: '',
	state: '',
	tel_no: '',
	fax_no: '',
	primary_density: '',
	primary_packaging_strategy: '',
	primary_carton_code: '',
	primary_carton_type: '',
	primary_packaging_material_type: '',
	primary_securement_type: '',
	primary_total_loaded: '',
	primary_outside_dimension: '',
	primary_dunnage_description: '',
	primary_labels: '',
	primary_container_ownership: '',
	primary_type_of_plastic_packaging_supplied_along_with_Parts: '',
	primary_is_the_packaging_collected_and_taken_back_by_supplier: '',
	primary_are_you_complying_to_pwm_epr_rules: '',
	primary_share_your_pwn_epr_registration: '',
	primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number: '',
	primary_are_you_complying_with_the_pwm_epr_labeling_requirement: '',
	primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
		'',
	primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
		'',
	primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
		'',
	primary_remarks_other_details: '',
	secondary_density: '',
	secondary_packaging_strategy: '',
	secondary_carton_code: '',
	secondary_carton_type: '',
	secondary_packaging_material_type: '',
	secondary_securement_type: '',
	secondary_total_loaded: '',
	secondary_outside_dimension: '',
	secondary_dunnage_description: '',
	secondary_labels: '',
	secondary_container_ownership: '',
	secondary_type_of_plastic_packaging_supplied_along_with_Parts: '',
	secondary_is_the_packaging_collected_and_taken_back_by_supplier: '',
	secondary_are_you_complying_to_pwm_epr_rules: '',
	secondary_share_your_pwn_epr_registration: '',
	secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
		'',
	secondary_are_you_complying_with_the_pwm_epr_labeling_requirement: '',
	secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
		'',
	secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
		'',
	secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
		'',
	secondary_remarks_other_details: '',
	transportation_mode: '',
	pallet_dimensions: '',
	no_of_pallets_per_vehicle: '',
	stackable_non_stackable: '',
	sec_packaging_per_transit_modes: '',
	no_of_pry_packs_per_sec_packs: '',
	inco_term: '',
	hazardous_material_class: '',
	loop_size: '',
	life_of_returnable_packaging: '',
	unloading_loading_responsibility: '',
	supply_at_tml: '',
	theoretical_cubic_utilisation: '',
	remarks: '',
	//packaging_person: '',
	//purchasing_buyer_tml: '',
	//scm_tml: '',
	//packaging_person_date: '',
	//purchasing_buyer_tml_date: '',
	//scm_tml_date: '',
	tata_motors_receiving_location: '',
	tml_part_no: '',
	tml_part_description: '',
	part_weight: '',
	part_dimensions: '',
	annual_volume: '',
	no_of_parts_per_vehicle: '',
	packaging_cost: '',
	transportation_cost: '',
	models_applicable: '',
	part_only_image: '',
	part_dunnage_primary_packaging_image: '',
	primary_plus_secondary_packaging_image: '',
	//approval_type: "",
	//approval_status: "",
	//approval_type_date: "",
	selected_plant_id: null,
	selected_dmp_user_details: null,
};

export const error_Message = {
	company_name: false,
	company_address: false,
	pkg_person_contact_name: false,
	email: false,
	vendor_code: false,
	state: false,
	tel_no: false,
	fax_no: false,
	primary_density: false,
	primary_packaging_strategy: false,
	primary_carton_code: false,
	primary_carton_type: false,
	primary_packaging_material_type: false,
	primary_securement_type: false,
	primary_total_loaded: false,
	primary_outside_dimension: false,
	primary_dunnage_description: false,
	primary_labels: false,
	primary_container_ownership: false,
	primary_type_of_plastic_packaging_supplied_along_with_Parts: false,
	primary_is_the_packaging_collected_and_taken_back_by_supplier: false,
	primary_are_you_complying_to_pwm_epr_rules: false,
	primary_share_your_pwn_epr_registration: false,
	primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number: false,
	primary_are_you_complying_with_the_pwm_epr_labeling_requirement: false,
	primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement: false,
	primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement: false,
	primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts: false,
	primary_remarks_other_details: false,
	secondary_density: false,
	secondary_packaging_strategy: false,
	secondary_carton_code: false,
	secondary_carton_type: false,
	secondary_packaging_material_type: false,
	secondary_securement_type: false,
	secondary_total_loaded: false,
	secondary_outside_dimension: false,
	secondary_dunnage_description: false,
	secondary_labels: false,
	secondary_container_ownership: false,
	secondary_type_of_plastic_packaging_supplied_along_with_Parts: false,
	secondary_is_the_packaging_collected_and_taken_back_by_supplier: false,
	secondary_are_you_complying_to_pwm_epr_rules: false,
	secondary_share_your_pwn_epr_registration: false,
	secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number: false,
	secondary_are_you_complying_with_the_pwm_epr_labeling_requirement: false,
	secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement: false,
	secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement: false,
	secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts: false,
	secondary_remarks_other_details: false,
	transportation_mode: false,
	pallet_dimensions: false,
	no_of_pallets_per_vehicle: false,
	stackable_non_stackable: false,
	sec_packaging_per_transit_modes: false,
	no_of_pry_packs_per_sec_packs: false,
	inco_term: false,
	hazardous_material_class: false,
	loop_size: false,
	life_of_returnable_packaging: false,
	unloading_loading_responsibility: false,
	supply_at_tml: false,
	theoretical_cubic_utilisation: false,
	remarks: false,
	//packaging_person: false,
	//purchasing_buyer_tml: false,
	//scm_tml: false,
	//packaging_person_date: false,
	//purchasing_buyer_tml_date: false,
	//scm_tml_date: false,
	tata_motors_receiving_location: false,
	tml_part_no: false,
	tml_part_description: false,
	part_weight: false,
	part_dimensions: false,
	annual_volume: false,
	no_of_parts_per_vehicle: false,
	packaging_cost: false,
	transportation_cost: false,
	models_applicable: false,
	part_only_image: false,
	part_dunnage_primary_packaging_image: false,
	primary_plus_secondary_packaging_image: false,
	//approval_type: false,
	//approval_status: false,
	//approval_type_date: false,
	selected_plant_id: false,
	selected_dmp_user_details: false,
};

export const primaryRequiredFields = [
	'primary_are_you_complying_to_pwm_epr_rules',
	'primary_share_your_pwn_epr_registration',
	'primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number',
	'primary_are_you_complying_with_the_pwm_epr_labeling_requirement',
	'primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement',
	'primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement',
	'primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts',
	'primary_remarks_other_details',
];

export const secondaryRequiredFields = [
	'secondary_are_you_complying_to_pwm_epr_rules',
	'secondary_share_your_pwn_epr_registration',
	'secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number',
	'secondary_are_you_complying_with_the_pwm_epr_labeling_requirement',
	'secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement',
	'secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement',
	'secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts',
	'secondary_remarks_other_details',
];

export const recommendedFields = [
	'part_only_image',
	'part_dunnage_primary_packaging_image',
	'primary_plus_secondary_packaging_image'
]

export const packagingDetailsRegex = {
	company_name: /^[\s\S]+$/, // Company names can include letters and spaces
	company_address: /^[\s\S]+$/, // Addresses can include letters, numbers, spaces, commas, and periods
	pkg_person_contact_name: /^[\s\S]+$/, // Contact names can include letters and spaces
	email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, // Basic email format validation
	vendor_code: /^[\s\S]+$/, // Vendor codes can include letters, numbers, and hyphens
	state: /^[\s\S]+$/, // State names can include letters and spaces
	tel_no: /^[0-9-]+$/, // Telephone numbers can include digits and hyphens
	fax_no: /^[0-9-]*$/, // Fax numbers can include digits and hyphens
	primary_density: /^[\s\S]+$/, // Density can be a positive number, including decimals
	primary_packaging_strategy: /^[\s\S]+$/, // Packaging strategy can include letters and spaces
	primary_carton_code: /^[\s\S]+$/, // Carton codes can include letters and numbers
	primary_carton_type: /^[\s\S]+$/, // Carton type can include letters and spaces
	primary_packaging_material_type: /^[\s\S]+$/, // Material types can include letters and spaces
	primary_securement_type: /^[\s\S]+$/, // Securement types can include letters and spaces
	primary_total_loaded: /^[\s\S]+$/, // Total loaded can be a positive integer
	primary_outside_dimension: /^([\dXx*,]+|NA|na)$/,
	primary_dunnage_description: /^[\s\S]+$/, // Dunnage description can include letters and spaces
	primary_labels: /^[\s\S]+$/, // Labels can include letters and spaces
	primary_container_ownership: /^[\s\S]+$/, // Container ownership can include letters and spaces
	primary_type_of_plastic_packaging_supplied_along_with_Parts: /^[\s\S]+$/, // Plastic packaging types can include letters and spaces
	//"primary_is_the_packaging_collected_and_taken_back_by_supplier": /^(yes|no)$/i, // Yes/No question
	primary_are_you_complying_to_pwm_epr_rules: /^[\s\S]+$/,
	primary_share_your_pwn_epr_registration: /^[\s\S]+$/, // Registration can include letters, numbers, and spaces
	primary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
		/^[\s\S]+$/, // Supplier registration number
	primary_are_you_complying_with_the_pwm_epr_labeling_requirement:
		/^[\s\S]+$/,
	primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
		/^[\s\S]+$/,
	primary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
		/^[\s\S]+$/,
	primary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
		/^\d+(\.\d+)|NA|na?$/, // Percentage values
	primary_remarks_other_details: /^[\s\S]+$/, // Remarks can include letters, numbers, spaces, and some punctuation
	secondary_density: /^\d+(\.\d+)?$/, // Secondary density can be a positive number, including decimals
	secondary_packaging_strategy: /^[\s\S]+$/, // Similar to primary
	secondary_carton_code: /^[\s\S]+$/, // Similar to primary
	secondary_carton_type: /^[\s\S]+$/, // Similar to primary
	secondary_packaging_material_type: /^[\s\S]+$/, // Similar to primary
	secondary_securement_type: /^[\s\S]+$/, // Similar to primary
	secondary_total_loaded: /^[\s\S]+$/, // Positive integer
	secondary_outside_dimension: /^([\dXx*,]+|NA|na)$/, // Positive number, including decimals
	secondary_dunnage_description: /^[\s\S]+$/, // Similar to primary
	secondary_labels: /^[\s\S]+$/, // Similar to primary
	secondary_container_ownership: /^[\s\S]+$/, // Similar to primary
	secondary_type_of_plastic_packaging_supplied_along_with_Parts:
		/^[\s\S]+$/, // Similar to primary
	//"secondary_is_the_packaging_collected_and_taken_back_by_supplier": /^(yes|no)$/i, // Yes/No question
	secondary_are_you_complying_to_pwm_epr_rules: /^[\s\S]+$/,
	secondary_share_your_pwn_epr_registration: /^[\s\S]+$/, // Similar to primary
	secondary_share_your_plastic_packaging_supplier_pwm_epr_registration_number:
		/^[\s\S]+$/, // Similar to primary
	secondary_are_you_complying_with_the_pwm_epr_labeling_requirement:
		/^[\s\S]+$/,
	secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycling_requirement:
		/^[\s\S]+$/,
	secondary_are_you_complying_with_the_pwn_epr_plastic_packaging_recycled_content_requirement:
		/^[\s\S]+$/,
	secondary_what_is_the_current_percent_of_recycled_content_in_the_plastic_packaging_of_the_parts:
		/^\d+(\.\d+)|NA|na?$/, // Percentage values
	secondary_remarks_other_details: /^[\s\S]+$/, // Similar to primary
	transportation_mode: /^[\s\S]+$/, // Transportation modes can include letters and spaces
	pallet_dimensions: /^([\dXx*,]+|NA|na)$/, // Dimensions can be a number, including decimals
	no_of_pallets_per_vehicle: /^[\s\S]+$/,
	stackable_non_stackable: /^[\s\S]+$/,
	sec_packaging_per_transit_modes: /^[\s\S]+$/, // Similar to primary
	no_of_pry_packs_per_sec_packs: /^[\s\S]+$/, // Positive integer
	inco_term: /^[\s\S]+$/, // Inco terms can include letters and spaces
	hazardous_material_class: /^[\s\S]+$/, // Material classes can include letters and spaces
	loop_size: /^[\s\S]+$/, // Addresses can include letters, numbers, spaces, commas, and periods
	life_of_returnable_packaging: /^[\s\S]+$/, // Addresses can include letters, numbers, spaces, commas, and periods
	unloading_loading_responsibility: /^[\s\S]+$/, // Similar to primary
	supply_at_tml: /^[\s\S]+$/, // Similar to primary
	theoretical_cubic_utilisation: /^[\s\S]+$/, // Positive number, including decimals
	remarks: /^[\s\S]+$/, // Similar to primary
	//"packaging_person": /^[A-Za-z\s]+$/, // Packaging person's name
	//"purchasing_buyer_tml": /^[A-Za-z\s]+$/, // Similar to primary
	//"scm_tml": /^[A-Za-z\s]+$/, // Similar to primary
	//"packaging_person_date": /^\d{4}-\d{2}-\d{2}$/, // Date format YYYY-MM-DD
	//"purchasing_buyer_tml_date": /^\d{4}-\d{2}-\d{2}$/, // Date format YYYY-MM-DD
	//"scm_tml_date": /^\d{4}-\d{2}-\d{2}$/, // Date format YYYY-MM-DD
	tata_motors_receiving_location: /^[\s\S]+$/, // Location names
	tml_part_no: /^[A-Za-z0-9-]+$/, // Part numbers can include letters, numbers, and hyphens
	tml_part_description: /^[\s\S]+$/, // Part descriptions
	part_weight: /^\d+(\.\d+)?$/, // Weight as a positive number
	part_dimensions: /^([\dXx*,]+|NA|na)$/, // Dimensions as a positive number
	annual_volume: /^\d+$/, // Positive integer
	no_of_parts_per_vehicle: /^[\s\S]+$/, // Positive integer
	packaging_cost: /^\d+(\.\d+)?$/, // Cost as a positive number
	transportation_cost: /^\d+(\.\d+)?$/, // Cost as a positive number
	models_applicable: /^[\s\S]+$/, // Model names
	// "part_only_image": /^[A-Za-z0-9\-_.]+\.(jpg|jpeg|png|gif)$/, // Image filenames with common extensions
	// "part_dunnage_primary_packaging_image": /^[A-Za-z0-9\-_.]+\.(jpg|jpeg|png|gif)$/, // Similar to above
	// "primary_plus_secondary_packaging_image": /^[A-Za-z0-9\-_.]+\.(jpg|jpeg|png|gif)$/, // Similar to above
	//"approval_type": /^[A-Za-z\s]+$/, // Approval type can include letters and spaces
	//"approval_status": /^[A-Za-z\s]+$/, // Approval status can include letters and spaces
};

export const requiredFields = [
	'company_name',
	'company_address',
	'pkg_person_contact_name',
	'email',
	'vendor_code',
	'state',
	'tel_no',
	'fax_no',
	'primary_density',
	'primary_packaging_strategy',
	'primary_carton_code',
	'primary_carton_type',
	'primary_packaging_material_type',
	'primary_securement_type',
	'primary_total_loaded',
	'primary_outside_dimension',
	'primary_dunnage_description',
	'primary_labels',
	'primary_container_ownership',
	'primary_type_of_plastic_packaging_supplied_along_with_Parts',
	'primary_is_the_packaging_collected_and_taken_back_by_supplier',
	'secondary_density',
	'secondary_packaging_strategy',
	'secondary_carton_code',
	'secondary_carton_type',
	'secondary_packaging_material_type',
	'secondary_securement_type',
	'secondary_total_loaded',
	'secondary_outside_dimension',
	'secondary_dunnage_description',
	'secondary_labels',
	'secondary_container_ownership',
	'secondary_type_of_plastic_packaging_supplied_along_with_Parts',
	'secondary_is_the_packaging_collected_and_taken_back_by_supplier',
	'transportation_mode',
	'pallet_dimensions',
	'stackable_non_stackable',
	'no_of_pallets_per_vehicle',
	'sec_packaging_per_transit_modes',
	'no_of_pry_packs_per_sec_packs',
	'inco_term',
	'hazardous_material_class',
	'loop_size',
	'life_of_returnable_packaging',
	'unloading_loading_responsibility',
	'supply_at_tml',
	'theoretical_cubic_utilisation',
	'remarks', //'packaging_person', 'purchasing_buyer_tml', 'scm_tml',
	// 'packaging_person_date', 'purchasing_buyer_tml_date', 'scm_tml_date',
	'tata_motors_receiving_location',
	'tml_part_no',
	'tml_part_description',
	'part_weight',
	'part_dimensions',
	'annual_volume',
	'no_of_parts_per_vehicle',
	'packaging_cost',
	'transportation_cost',
	'models_applicable',
	'excel_attachment',
	//'selected_plant_id',
	//'selected_dmp_user_details'
];

export const errorMsg = {
	errorMsgForCompanyName:
		'Invalid Company Name. Please Enter A valid Company Name.',
	errorMsgForCompanyAddress:
		'Invalid Company Address. Please Enter A valid Company Address.',
	errorMsgForPkgPersonContactName:
		'Invalid Packaging Person Contact Name. Enter in the following format :- John Doe.',
	errorMsgForEmail: `Invalid Email. Enter in the following format :- TataMotors${new Date().getFullYear()}@example.com.`,
	errorMsgForVendorCode:
		'Invalid Vendor Code. Enter in the following format :- V2024.',
	errorMsgForState: 'Invalid State. Please Enter A valid State Name.',
	errorMsgForTelNo:
		'Invalid Telephone Number. Enter in the following format :- 1234567890.',
	errorMsgForFaxNo:
		'Invalid Fax Number. Enter in the following format :- 1234567890.',

	// Primary packaging fields
	errorMsgForPrimaryDensity:
		'Invalid Primary Density. Please provide a valid density value.',
	errorMsgForPrimaryPackagingStrategy:
		'Invalid Primary Packaging Strategy. Please provide a valid strategy.',
	errorMsgForPrimaryCartonCode:
		'Invalid Primary Carton Code. Please provide a valid carton code.',
	errorMsgForPrimaryCartonType:
		'Invalid Primary Carton Type. Please provide a valid carton type.',
	errorMsgForPrimaryPackagingMaterialType:
		'Invalid Primary Packaging Material Type. Please provide a valid material type.',
	errorMsgForPrimarySecurementType:
		'Invalid Primary Securement Type. Please provide a valid securement type.',
	errorMsgForPrimaryTotalLoaded:
		'Invalid Primary Total Loaded. Please provide a valid value.',
	errorMsgForPrimaryOutsideDimension:
		'Invalid Primary Outside Dimension. Please provide a valid dimension.',
	errorMsgForPrimaryDunnageDescription:
		'Invalid Primary Dunnage Description. Please provide a valid description.',
	errorMsgForPrimaryLabels:
		'Invalid Primary Labels. Please provide valid labels.',
	errorMsgForPrimaryContainerOwnership:
		'Invalid Primary Container Ownership. Please provide a valid ownership detail.',
	errorMsgForPrimaryPlasticPackagingSupplied:
		'Invalid Primary Plastic Packaging Supplied. Please provide valid information.',
	errorMsgForPrimaryPackagingCollected:
		'Invalid information on Primary Packaging Collection. Please provide valid information.',
	errorMsgForPrimaryComplianceToPWM:
		'Invalid compliance to PWM EPR Rules. Please provide valid compliance details.',
	errorMsgForPrimaryPWNRegistration:
		'Invalid Primary PWN EPR Registration. Please provide valid registration details.',
	errorMsgForPrimarySupplierRegistrationNumber:
		'Invalid Primary Plastic Packaging Supplier PWM EPR Registration Number. Please provide valid registration number.',
	errorMsgForPrimaryLabelingRequirement:
		'Invalid compliance with PWM EPR Labeling Requirement. Please provide valid information.',
	errorMsgForPrimaryRecyclingRequirement:
		'Invalid compliance with PWM EPR Plastic Packaging Recycling Requirement. Please provide valid compliance.',
	errorMsgForPrimaryRecycledContentRequirement:
		'Invalid compliance with PWM EPR Plastic Packaging Recycled Content Requirement. Please provide valid compliance.',
	errorMsgForPrimaryRecycledContentPercent:
		'Invalid percentage for Recycled Content in the Primary Packaging. Please provide a valid percentage.',
	errorMsgForPrimaryRemarks:
		'Invalid Primary Remarks or Other Details. Please provide valid remarks.',

	// Secondary packaging fields
	errorMsgForSecondaryDensity:
		'Invalid Secondary Density. Please provide a valid density value.',
	errorMsgForSecondaryPackagingStrategy:
		'Invalid Secondary Packaging Strategy. Please provide a valid strategy.',
	errorMsgForSecondaryCartonCode:
		'Invalid Secondary Carton Code. Please provide a valid carton code.',
	errorMsgForSecondaryCartonType:
		'Invalid Secondary Carton Type. Please provide a valid carton type.',
	errorMsgForSecondaryPackagingMaterialType:
		'Invalid Secondary Packaging Material Type. Please provide a valid material type.',
	errorMsgForSecondarySecurementType:
		'Invalid Secondary Securement Type. Please provide a valid securement type.',
	errorMsgForSecondaryTotalLoaded:
		'Invalid Secondary Total Loaded. Please provide a valid value.',
	errorMsgForSecondaryOutsideDimension:
		'Invalid Secondary Outside Dimension. Please provide a valid dimension.',
	errorMsgForSecondaryDunnageDescription:
		'Invalid Secondary Dunnage Description. Please provide a valid description.',
	errorMsgForSecondaryLabels:
		'Invalid Secondary Labels. Please provide valid labels.',
	errorMsgForSecondaryContainerOwnership:
		'Invalid Secondary Container Ownership. Please provide a valid ownership detail.',
	errorMsgForSecondaryPlasticPackagingSupplied:
		'Invalid Secondary Plastic Packaging Supplied. Please provide valid information.',
	errorMsgForSecondaryPackagingCollected:
		'Invalid information on Secondary Packaging Collection. Please provide valid information.',
	errorMsgForSecondaryComplianceToPWM:
		'Invalid compliance to PWM EPR Rules for Secondary Packaging. Please provide valid compliance details.',
	errorMsgForSecondaryPWNRegistration:
		'Invalid Secondary PWN EPR Registration. Please provide valid registration details.',
	errorMsgForSecondarySupplierRegistrationNumber:
		'Invalid Secondary Plastic Packaging Supplier PWM EPR Registration Number. Please provide valid registration number.',
	errorMsgForSecondaryLabelingRequirement:
		'Invalid compliance with Secondary PWM EPR Labeling Requirement. Please provide valid information.',
	errorMsgForSecondaryRecyclingRequirement:
		'Invalid compliance with Secondary PWM EPR Plastic Packaging Recycling Requirement. Please provide valid compliance.',
	errorMsgForSecondaryRecycledContentRequirement:
		'Invalid compliance with Secondary PWM EPR Plastic Packaging Recycled Content Requirement. Please provide valid compliance.',
	errorMsgForSecondaryRecycledContentPercent:
		'Invalid percentage for Recycled Content in the Secondary Packaging. Please provide a valid percentage.',
	errorMsgForSecondaryRemarks:
		'Invalid Secondary Remarks or Other Details. Please provide valid remarks.',

	// Other logistics fields
	errorMsgForTransportationMode:
		'Invalid Transportation Mode. Please provide a valid mode.',
	errorMsgForPalletDimensions:
		'Invalid Pallet Dimensions. Please provide valid dimensions.',
	errorMsgForSecPackagingPerTransitModes:
		'Invalid Secondary Packaging per Transit Modes. Please provide valid information.',
	errorMsgForNoOfPryPacksPerSecPacks:
		'Invalid number of Primary Packs per Secondary Packs. Please provide a valid number.',
	errorMsgForIncoTerm: 'Invalid Incoterm. Please provide a valid incoterm.',
	errorMsgForHazardousMaterialClass:
		'Invalid Hazardous Material Class. Please provide a valid class.',
	errorMsgForLoopSize: 'Invalid Loop Size. Please provide a valid loop size.',
	errorMsgForLifeOfReturnablePackaging:
		'Invalid Life of Returnable Packaging. Please provide a valid lifespan.',
	errorMsgForUnloadingLoadingResponsibility:
		'Invalid Unloading and Loading Responsibility. Please provide valid information.',
	errorMsgForSupplyAtTML:
		'Invalid Supply at TML. Please provide valid information.',
	errorMsgForTheoreticalCubicUtilisation:
		'Invalid Theoretical Cubic Utilisation. Please provide valid utilization percentage.',
	errorMsgForRemarks: 'Invalid Remarks. Please provide valid remarks.',
	errorMsgForPackagingPerson:
		'Invalid Packaging Person. Please provide a valid name.',
	errorMsgForPurchasingBuyerTML:
		'Invalid Purchasing Buyer at TML. Please provide valid information.',
	errorMsgForSCMTML: 'Invalid SCM TML. Please provide valid information.',
	errorMsgForPackagingPersonDate:
		'Invalid Packaging Person Date. Please provide a valid date.',
	errorMsgForPurchasingBuyerTMLDate:
		'Invalid Purchasing Buyer TML Date. Please provide a valid date.',
	errorMsgForSCMTMLDate: 'Invalid SCM TML Date. Please provide a valid date.',
	errorMsgForTataMotorsReceivingLocation:
		'Invalid Tata Motors Receiving Location. Please provide valid information.',
	errorMsgForTMLPartNo:
		'Invalid TML Part Number. Please provide a valid part number.',
	errorMsgForTMLPartDescription:
		'Invalid TML Part Description. Please provide a valid description.',
	errorMsgForPartWeight: 'Invalid Part Weight. Please provide a valid weight.',
	errorMsgForPartDimensions:
		'Invalid Part Dimensions. Please provide valid dimensions.',
	errorMsgForAnnualVolume:
		'Invalid Annual Volume. Please provide a valid volume.',
	errorMsgForNoOfPartsPerVehicle:
		'Invalid Number of Parts per Vehicle. Please provide a valid number.',
	errorMsgForPackagingCost:
		'Invalid Packaging Cost. Please provide a valid cost.',
	errorMsgForTransportationCost:
		'Invalid Transportation Cost. Please provide a valid cost.',
	errorMsgForModelsApplicable:
		'Invalid Models Applicable. Please provide valid models information.',
	errorMsgForPartOnlyImage:
		'Invalid Part Only Image. Please upload a valid image.',
	errorMsgForPartDunnagePrimaryPackagingImage:
		'Invalid Part Dunnage Primary Packaging Image. Please upload a valid image.',
	errorMsgForPrimaryPlusSecondaryPackagingImage:
		'Invalid Primary Plus Secondary Packaging Image. Please upload a valid image.',
	errorMsgForApprovalType:
		'Invalid Approval Type. Please provide a valid Approval Type',
	errorMsgForApprovalStatus:
		'Invalid Approval Status. Please provide a valid Approval Status',
	errorMsgForApprovalTypeDate:
		'Invalid Approval Type Date, Please provide a valid Approval Type Date.',
	errorMsgForStackable:
		'Invalid Stack, Please provide a valid Stackable or Non Stackable Information.',
	errorMsgForNoOfPalletPerVehicle:
		'Invalid No of pallets per vehicle, Please Provide a valid number of pallets per vehicle',
};
